import React from 'react';
import cs from 'classnames';
import { NOTECARD_EDITOR_TEXT_FORMAT_NAMES } from '../constants';
import { NotecardEditorSelectWrapper } from '../notecard-editor-select-wrapper';
import classes from './notecard-editor-select-text-property.scss';
import animationClasses from './notecard-editor-select-text-property-animation.scss';
const TEXT_FORMAT = 'Text format';
const buttonsData = [{
  type: NOTECARD_EDITOR_TEXT_FORMAT_NAMES.BOLD,
  additionalClasses: [],
  label: 'B'
}, {
  type: NOTECARD_EDITOR_TEXT_FORMAT_NAMES.ITALIC,
  additionalClasses: [classes.italic],
  label: 'I'
}, {
  type: NOTECARD_EDITOR_TEXT_FORMAT_NAMES.UNDERLINE,
  additionalClasses: [classes.underline],
  label: 'U'
}];
export const NotecardEditorSelectTextProperty = ({
  handleSelectStyleChange,
  selectionStyles,
  isOpened,
  toggleOpened
}) => {
  const getIsItemSelected = value => {
    return selectionStyles.includes(value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(NotecardEditorSelectWrapper, {
    toggleOpened: toggleOpened,
    isOpened: isOpened,
    animationClasses: animationClasses,
    name: TEXT_FORMAT
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentContainer
  }, buttonsData.map(({
    type,
    additionalClasses,
    label
  }) => /*#__PURE__*/React.createElement("button", {
    className: cs(classes.button, ...additionalClasses, {
      [classes.buttonSelected]: getIsItemSelected(type)
    }),
    key: type,
    onClick: () => handleSelectStyleChange(type)
  }, label)))));
};